import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const TermsList = styled('ul')(({ theme }) => ({
  ...theme.typography.body1R,
  lineHeight: 1.5,
  color: theme.palette.neutrals.lead,
  margin: 0,
  paddingLeft: theme.spacing(2.5)
}));

export const TermsNote = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2R,
  lineHeight: 1.5,
  color: theme.palette.neutrals.lead
}));

export const TermsCheckboxRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',

  cursor: 'pointer',
  width: '100%'
}));
